// Real Etia Media links & assets. Paste the real values here and every button updates site-wide.
// whatsapp: full wa.me link, e.g. "https://wa.me/447123456789"
// showreel: YouTube / Vimeo URL or direct .mp4 link — press play embeds it automatically
// portrait: image URL of Jacques for the About section
export const LINKS = {
  whatsapp: "https://wa.me/447496160249",
  youtube: "https://www.youtube.com/@JACQUESETIA",
  instagram: "https://www.instagram.com/jacquesetia_/",
  tiktok: "https://www.tiktok.com/@jacquesetia",
  showreel: "/videos/wedding-2.mp4",
  portrait: "/images/jacques-portrait.webp",
  heroVideo: "https://videos.pexels.com/video-files/2795750/2795750-hd_1920_1080_25fps.mp4",
};
